import { cn } from '@/lib/utils'

export function HeroKicker({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return <span className={cn('hero-kicker', className)}>{children}</span>
}
